import { colors } from "@material-ui/core";
import React from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const CredentialsModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings, id } = existingConfig;

  const limitSettings = ["apiKey"];

  if (!id) {
    limitSettings.push("preferAnonymousIdForDeviceId");
  }

  return (
    <ConfigureDestinationsModal
      limitSettings={limitSettings}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      title="Credentials"
      existingConfig={existingConfig}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen, existingConfig }) => {
  const { settings: allSettings } = existingConfig;
  const idSet = !!allSettings.apiKey;

  return (
    <DestinationConfigRow
      name="Credentials"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings, id } = existingConfig;

  const limitSettings = ["forceHttps", "useLogRevenueV2"];

  if (id) {
    limitSettings.push("preferAnonymousIdForDeviceId");
  }

  return (
    <ConfigureDestinationsModal
      limitSettings={limitSettings}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen, existingConfig }) => {
  const config = existingConfig.settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Options"
      labelText=""
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const EventTrackingModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const allSettings = existingConfig.settings;

  return (
    <ConfigureDestinationsModal
      limitSettings={[
        "trackReferrer",
        "trackUtmProperties",
        "trackGclid",
        "saveParamsReferrerOncePerSession",
      ]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      title="Event tracking"
      existingConfig={existingConfig}
    />
  );
};

const EventTrackingRow = ({ setConfigModalOpen, existingConfig }) => {
  const config = existingConfig.settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Event tracking"
      labelText=""
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const BatchingModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const allSettings = existingConfig.settings;

  return (
    <ConfigureDestinationsModal
      limitSettings={[
        "batchEvents",
        "eventUploadThreshold",
        "eventUploadPeriodMillis",
      ]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      title="Batching"
      existingConfig={existingConfig}
    />
  );
};

const BatchingRow = ({ setConfigModalOpen, existingConfig }) => {
  const config = existingConfig.settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Batching"
      labelText=""
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const EVENT_TRACKING = "EVENT_TRACKING";
const BATCHING = "BATCHING";
const OPTIONS = "OPTIONS";

const Rows = {
  CREDENTIALS: CredentialsRow,
  OPTIONS: ConfigurationRow,
  EVENT_TRACKING: EventTrackingRow,
  BATCHING: BatchingRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  OPTIONS: ConfigurationModal,
  EVENT_TRACKING: EventTrackingModal,
  BATCHING: BatchingModal,
};

const RowOrder = [CREDENTIALS, OPTIONS, EVENT_TRACKING, BATCHING];

export default {
  Rows,
  RowOrder,
  Modals,
};
